import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import Loader from 'atoms/Loader/Loader';
import styles from './PhotoPreview.module.scss';
function PhotoPreview({ src, alt, ratio = 1.6, radius = false, fullWidth = true, objectFit, }) {
    const [detectedFit, setDetectedFit] = useState('cover');
    const [isLoaded, setIsLoaded] = useState(false);
    useEffect(() => {
        setIsLoaded(false);
        setDetectedFit('cover');
    }, [src]);
    const resolvedFit = objectFit !== null && objectFit !== void 0 ? objectFit : detectedFit;
    function handleLoad(event) {
        const img = event.currentTarget;
        if (!img.naturalWidth || !img.naturalHeight)
            return;
        const imageRatio = img.naturalWidth / img.naturalHeight;
        const factor = Math.max(imageRatio, ratio) / Math.min(imageRatio, ratio);
        setDetectedFit(factor <= 1.3 ? 'cover' : 'contain');
        setIsLoaded(true);
    }
    return (React.createElement("div", { className: classNames(styles.wrap, {
            [styles.radius]: radius,
            [styles.fullWidth]: fullWidth,
        }), style: { paddingBottom: `${(1 / ratio) * 100}%` } }, src && (React.createElement(React.Fragment, null,
        React.createElement("img", { src: src, alt: alt, className: styles.img, style: { objectFit: resolvedFit }, onLoad: handleLoad }),
        !isLoaded && (React.createElement("div", { className: styles.loaderWrap },
            React.createElement(Loader, { noMargin: true, size: "m" })))))));
}
export default PhotoPreview;
